/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface McpOAuthTokenResponse
 */
export interface McpOAuthTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof McpOAuthTokenResponse
     */
    accessToken: string;
    /**
     * 
     * @type {McpOAuthTokenResponseTokenTypeEnum}
     * @memberof McpOAuthTokenResponse
     */
    tokenType: McpOAuthTokenResponseTokenTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof McpOAuthTokenResponse
     */
    expiresIn: number;
    /**
     * 
     * @type {string}
     * @memberof McpOAuthTokenResponse
     */
    refreshToken: string;
    /**
     * 
     * @type {McpOAuthTokenResponseScopeEnum}
     * @memberof McpOAuthTokenResponse
     */
    scope: McpOAuthTokenResponseScopeEnum;
}


/**
 * @export
 */
export const McpOAuthTokenResponseTokenTypeEnum = {
    Bearer: 'Bearer'
} as const;
export type McpOAuthTokenResponseTokenTypeEnum = typeof McpOAuthTokenResponseTokenTypeEnum[keyof typeof McpOAuthTokenResponseTokenTypeEnum];

/**
 * @export
 */
export const McpOAuthTokenResponseScopeEnum = {
    McpRead: 'mcp:read'
} as const;
export type McpOAuthTokenResponseScopeEnum = typeof McpOAuthTokenResponseScopeEnum[keyof typeof McpOAuthTokenResponseScopeEnum];


/**
 * Check if a given object implements the McpOAuthTokenResponse interface.
 */
export function instanceOfMcpOAuthTokenResponse(value: object): value is McpOAuthTokenResponse {
    if ((!('accessToken' in (value as Record<string, any>)) && !('access_token' in (value as Record<string, any>))) || ((value as Record<string, any>)['accessToken'] === undefined && (value as Record<string, any>)['access_token'] === undefined)) return false;
    if ((!('tokenType' in (value as Record<string, any>)) && !('token_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['tokenType'] === undefined && (value as Record<string, any>)['token_type'] === undefined)) return false;
    if ((value as Record<string, any>)['tokenType'] !== 'Bearer' && (value as Record<string, any>)['token_type'] !== 'Bearer') return false;
    
    if ((!('expiresIn' in (value as Record<string, any>)) && !('expires_in' in (value as Record<string, any>))) || ((value as Record<string, any>)['expiresIn'] === undefined && (value as Record<string, any>)['expires_in'] === undefined)) return false;
    if ((!('refreshToken' in (value as Record<string, any>)) && !('refresh_token' in (value as Record<string, any>))) || ((value as Record<string, any>)['refreshToken'] === undefined && (value as Record<string, any>)['refresh_token'] === undefined)) return false;
    if (!('scope' in value) || value['scope'] === undefined) return false;
    if (value['scope'] !== 'mcp:read') return false;
    
    return true;
}

export function McpOAuthTokenResponseFromJSON(json: any): McpOAuthTokenResponse {
    return McpOAuthTokenResponseFromJSONTyped(json, false);
}

export function McpOAuthTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): McpOAuthTokenResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'accessToken': json['access_token'],
        'tokenType': json['token_type'],
        'expiresIn': json['expires_in'],
        'refreshToken': json['refresh_token'],
        'scope': json['scope'],
    };
}

export function McpOAuthTokenResponseToJSON(json: any): McpOAuthTokenResponse {
    return McpOAuthTokenResponseToJSONTyped(json, false);
}

export function McpOAuthTokenResponseToJSONTyped(value?: McpOAuthTokenResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'access_token': value['accessToken'],
        'token_type': value['tokenType'],
        'expires_in': value['expiresIn'],
        'refresh_token': value['refreshToken'],
        'scope': value['scope'],
    };
}

